import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-restricted-internationalization',
  templateUrl: './restricted-internationalization.component.html',
  styleUrls: ['./restricted-internationalization.component.scss']
})
export class RestrictedInternationalizationComponent implements OnInit {

  @Input() isNew: boolean = true;
  @Input() isTranslation: boolean = true;
  @Input() editingLanguage: string = 'en-US';
  @Input() availableLanguages: Array<TranslatedLanguage> = [];
  @Input() translatedLanguages: Array<TranslatedLanguage> = [];
  @Input() translatedContent: any = [{}];
  @Input() translatedKeys: string[] = [];

  constructor() {
  }

  ngOnInit() {
  }

  getOnlyEnglish() {
    return this.availableLanguages.filter(x => x.code == 'en-US');
  }

  addLanguage(item: TranslatedLanguage): void {

    for (var i = 0; i < this.availableLanguages.length; i++) {
      if (this.availableLanguages[ i ].code == item.code) {
        this.translatedLanguages.push(this.availableLanguages[ i ]);
        this.availableLanguages.splice(i, 1);

        this.translatedContent[ item.code ] = [{}];
        for (var j = 0; j < this.translatedKeys.length; j++) {
          this.translatedContent[ item.code ][ this.translatedKeys[ j ] ] = '';
        }
        break;
      }
    }

    this.editLanguage(item.code);
  }

  editLanguage(code: string): void {
    if (code == 'en-US') {
      this.isTranslation = false;
    } else {
      this.isTranslation = true;
    }


    this.editingLanguage = code;
  }

}

export class TranslatedLanguage {
  id: string;
  code: string;
  name: string;
  flag: string;
  createOn: string;
  updatedAt: string;

  constructor() {
    this.code = 'en-US';
    this.flag = 'us';
    this.name = 'English (USA)';
    this.createOn = '';
    this.updatedAt = '';
  }
}
